/**
 * Optional chaining (`?.`) removed — coupon-common is a separate
 * package/folder from src/, and its Babel config doesn't appear to include
 * the optional-chaining transform (webpack/CRA typically only run
 * babel-loader with full plugin support against src/ by default). Rewrote
 * the one `?.` usage with a plain guard instead of requiring a build-config
 * change.
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { OK } from 'http-status-codes';

import { types, actions } from './duck';
import { getCouponsByBusinessIds } from '../../coupons/api';

export function* getCouponsByBusinessIdsSaga({ businessIds }) {
  try {
    yield put(actions.getCouponsByBusinessIdsRequest());
    const response = yield call(getCouponsByBusinessIds, businessIds);

    if (response.status === OK) {
      yield put(actions.getCouponsByBusinessIdsSuccess(response.data));
    } else {
      const error = Array.isArray(response.data)
        ? response.data[0]
        : response.data && response.data.detail;
      yield put(actions.getCouponsByBusinessIdsFailure(error));
    }
  } catch (error) {
    yield put(actions.getCouponsByBusinessIdsFailure(error.message));
  }
}

export default function* saga() {
  yield takeLatest(types.GET_COUPONS_BY_BUSINESS_IDS, getCouponsByBusinessIdsSaga);
}